import axios from 'axios';

export const devUrl = "https://jec8wza0c5.execute-api.us-east-2.amazonaws.com/dev";
export const prodUrl = "https://jec8wza0c5.execute-api.us-east-2.amazonaws.com/prod";

// export const usedUrl = process.env.REACT_APP_ENV === 'production' ? prodUrl : devUrl;
export const usedUrl = prodUrl;

export const GET = (url, config) => axios.get(usedUrl+url, {...config})

export const POST = (url,data,config) => axios.post(usedUrl+url, data, config)

export const DELETE = (url,config) => axios.delete(usedUrl+url,config);

export const PATCH = (url,data,config) => axios.patch(usedUrl+url,data,config)

export const PUT = (url,data,config) => axios.put(usedUrl+url,data,config)
